import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";


import { createUseStyles } from "react-jss";

import { rows, value } from "variables/pricing";

import { UserContext } from "services/auth";
import { signInWithGoogle } from "services/firebase";

import styles from "assets/jss/material-dashboard-pro-react/views/pricingStyle.js";
// import { sendToCheckoutSession } from "services/stripe";
import { isUserPremium } from "services/firebase";

const useStyles = createUseStyles(styles);

export default function Pricing() {
  const classes = useStyles();
  const [user] = React.useContext(UserContext);
  const [loading, setLoading] = React.useState(false);
  const [premium, setPremium] = React.useState(false);

  React.useEffect(() => {
    const loadPremium = async () => {
      const _premium = await isUserPremium();
      setPremium(_premium);
      return _premium;
    };
    loadPremium();
  }, [user]);

  const handleSubscribe = () => {
    if (user || premium) {
      return;
    } else {
      signInWithGoogle();
    }
  };

  const loadButton = () => {
    return (
      <Button
        color="secondary"
        classes={{
          label: classes.buyLabel,
          root: classes.buyRoot,
        }}
        onClick={handleSubscribe}
        style={{ width: "160px" }} // For same width when circular progress
      >
        {loading ? (
          <CircularProgress color="secondary" />
        ) : (
          <span>
            {premium && <Typography variant="h6">You have Premium!</Typography>}
            {!premium && <Typography variant="h6">Sign up</Typography>}
          </span>
        )}
      </Button>
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <TableContainer className={classes.table}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="center" sx={{width: "25%"}}>Starter</TableCell>
              <TableCell align="center" sx={{width: "25%"}}>Premium (free to use!)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, key) => (
                <TableRow key={key}>
                  <TableCell component="th" scope="row">
                    {row.title}
                  </TableCell>
                  <TableCell align="center">{value(row.freeValue)}</TableCell>
                  <TableCell align="center">{value(row.plusValue)}</TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  className={classes.endRow}
                >Pricing</TableCell>
                <TableCell align="center" className={classes.endRow}>
                  <Typography noWrap>Free</Typography>
                </TableCell>
                 <TableCell align="center" className={classes.endRow}>
                  {loadButton()}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}
